/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  // Custom code: lazy pdf
  console.log("run")
  document.addEventListener("DOMContentLoaded", function initLazyPDFs() {
    console.log("run")
    const pdfs = document.querySelectorAll("[data-lazy-load-pdf]")
    pdfs.forEach(function (el) {
      console.log({el})
      const observer = new IntersectionObserver((entries, obs) => {
      if (entries[0].isIntersecting) {
          el.src = el.dataset.src;
          obs.disconnect();
        }
      });
      observer.observe(el);
    })
  })







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
